import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@urc-ui/store/api/base';
import { HttpMethod } from '@urc-ui/store/api/types';
import { resolveAdvertisingApiBaseUrl } from '@urc-ui/store/api/ross/utils';
import { exponentialBackoffWithJitter, getFrbAuthorizationHeaders } from '@flexible-reports/store/api/base';
import { QueryAnalysisWorkspaceConfigurationsRequest, QueryAnalysisWorkspaceConfigurationsResponse } from './api-types';

export const analysisWorkspaceApi = createApi({
  reducerPath: 'analysisWorkspaceApi',
  baseQuery: retry(
    axiosBaseQuery({
      baseUrl: resolveAdvertisingApiBaseUrl()
    }),
    exponentialBackoffWithJitter({ baseDelay: 50, maxDelay: 5000, maxRetries: 5 })
  ),
  endpoints: builder => ({
    queryAnalysisWorkspaceConfigurations: builder.query<
      QueryAnalysisWorkspaceConfigurationsResponse,
      QueryAnalysisWorkspaceConfigurationsRequest
    >({
      query: (request: QueryAnalysisWorkspaceConfigurationsRequest) => ({
        url: '/adsApi/v1/query/analysisWorkspaceConfigurations',
        method: HttpMethod.POST,
        headers: getFrbAuthorizationHeaders(),
        data: request
      })
    })
  })
});

export const { useLazyQueryAnalysisWorkspaceConfigurationsQuery, useQueryAnalysisWorkspaceConfigurationsQuery } = analysisWorkspaceApi;
